import {
   DELETE_TERMINAL_FAILED , DELETE_TERMINAL_REMOVE , DELETE_TERMINAL_SUCCESS , DELETE_TERMINAL_LOADING
   } from "../types";
   
   const initialState = {
     loading: false,
     error: null,
     status: null,
     message:null ,
   };
   
   export const DeleteTerminalReducer = (
     state = initialState,
     action: { type: any; loading:boolean , payload: any, error: any, status: string , message : string  }
   ) => {
     switch (action.type) {
       case DELETE_TERMINAL_LOADING:
         return {
           ...state,
           loading: action.loading,
         };
       case DELETE_TERMINAL_SUCCESS:
        //
         return {
           ...state,
           loading: false,
           status: action.payload,
           message:action.payload ,
           error: null,
         };
       case DELETE_TERMINAL_FAILED:
         return {
           ...state,
           loading: false,
           status: null,
           message:null , 
           error: action.error,
         };
         case DELETE_TERMINAL_REMOVE : 
         return {
           ...state, 
           loading: false,
           status: null,
           message:null , 
           error: null ,
 
         }
       default:
         return state;
     }
   };
   